module.exports = __webpack_public_path__ + "static/img/pro11.b74757ea.png";